(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["trigonal-contact-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const form = document.getElementById('TGContactForm');
    if (!form) return;
    const state = document.getElementById('TGContactState');
    const error = document.getElementById('TGContactClientError');
    const requiredMessage = document.getElementById('TGContactRequiredError').textContent;
    const fields = [...form.querySelectorAll('input[required], textarea[required]')];
    const key = 'trigonal-contact-draft-v1';
    let attempted = false;
    function saveDraft() {
      try {
        const values = Object.fromEntries(fields.map(field => [field.name, field.value]));
        sessionStorage.setItem(key, JSON.stringify({ values, attempted, savedAt: Date.now() }));
      } catch (_) {}
    }
    function restoreDraft() {
      if (state.dataset.success === 'true') {
        try { sessionStorage.removeItem(key); } catch (_) {}
        return;
      }
      try {
        const draft = JSON.parse(sessionStorage.getItem(key));
        if (!draft) return;
        if (Date.now() - draft.savedAt > 30 * 60 * 1000) {
          sessionStorage.removeItem(key);
          return;
        }
        fields.forEach(field => { if (!field.value && typeof draft.values[field.name] === 'string') field.value = draft.values[field.name]; });
        attempted = draft.attempted;
        if (attempted && state.dataset.serverError !== 'true') {
          error.textContent = error.dataset.pending;
          error.hidden = false;
        }
      } catch (_) {}
    }
    function validate(field) {
      field.setCustomValidity(field.value.trim() ? '' : requiredMessage);
    }
    fields.forEach(field => {
      field.addEventListener('input', () => { validate(field); saveDraft(); });
      field.addEventListener('change', () => { validate(field); saveDraft(); });
    });
    form.addEventListener('submit', event => {
      fields.forEach(validate);
      if (!form.reportValidity()) { event.preventDefault(); return; }
      attempted = true;
      saveDraft();
      if (!navigator.onLine) {
        event.preventDefault();
        error.textContent = error.dataset.offline;
        error.hidden = false;
      }
    });
    window.addEventListener('pageshow', restoreDraft);
    restoreDraft();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["trigonal-hero"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tg-hero-media')) {
  customElements.define('tg-hero-media', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 899px)');
      this.userPaused = false;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.button.hidden = false;
      this.video.addEventListener('playing', () => {
        const reveal = () => {
          if (this.video.paused || (this.motion.matches && !this.hasAttribute('data-manual-play'))) return;
          this.setAttribute('data-frame-visible','');
          this.button.textContent = this.button.dataset.pause;
        };
        if (this.video.requestVideoFrameCallback) this.video.requestVideoFrameCallback(reveal);
        else requestAnimationFrame(reveal);
      }, options);
      this.video.addEventListener('pause', () => { this.button.textContent = this.button.dataset.play; }, options);
      this.video.addEventListener('error', () => this.fallback(), options);
      this.button.addEventListener('click', () => {
        if (!this.video.paused) {
          this.userPaused = true;
          this.video.pause();
          if (this.motion.matches) this.fallback();
        } else {
          this.userPaused = false;
          this.setAttribute('data-manual-play','');
          this.start(true);
        }
      }, options);
      this.motion.addEventListener('change', () => {
        this.removeAttribute('data-manual-play');
        if (this.motion.matches) {
          this.video.pause();
          this.video.removeAttribute('src');
          this.video.load();
          this.fallback();
        } else if (!this.userPaused) this.start();
      }, options);
      this.mobile.addEventListener('change', () => {
        const continuePlaying = !this.video.paused;
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.load();
        this.fallback();
        if (continuePlaying && !this.motion.matches) this.start();
      }, options);
      if (!this.motion.matches) this.start();
    }
    start(manual = false) {
      if (!manual && (this.motion.matches || this.userPaused)) return;
      const source = this.mobile.matches ? this.dataset.mobile : this.dataset.desktop;
      if (this.video.getAttribute('src') !== source) {
        this.video.src = source;
        this.video.preload = 'auto';
        this.video.load();
      }
      this.video.muted = true;
      this.video.autoplay = !this.motion.matches;
      const attempt = this.video.play();
      if (attempt) attempt.catch(() => this.fallback());
    }
    fallback() {
      this.removeAttribute('data-frame-visible');
      this.removeAttribute('data-manual-play');
      this.button.textContent = this.button.dataset.play;
    }
    disconnectedCallback() {
      this.video?.pause();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["trigonal-rattan-setup-only"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => document.querySelectorAll('[data-rattan-setup]').forEach(setup => {
    if (setup.dataset.ready) return;
    const form = setup.closest('form');
    const quantity = setup.querySelector('[name="quantity"]');
    if (!form || !quantity) return;
    setup.dataset.ready = 'true';
    const buttons = [...setup.querySelectorAll('[data-rattan-pairs]')];
    const group = setup.querySelector('[data-rattan-subquantity]');
    let previousMode = 'one-time';
    let oneTimeQuantity = 1;
    const mode = () => {
      const selected = form.querySelector('input[name="selling_plan"]:checked');
      return selected && (selected.getAttribute('data-appstle-real-value') || selected.value) ? 'subscription' : 'one-time';
    };
    const setQuantity = value => {
      quantity.value = String(value);
      quantity.dispatchEvent(new Event('input', {bubbles:true}));
    };
    const refresh = () => {
      const current = mode();
      if (current !== previousMode) {
        setQuantity(current === 'subscription' ? 1 : oneTimeQuantity);
        previousMode = current;
      }
      const hidden = current !== 'subscription';
      if (group.hidden !== hidden) group.hidden = hidden;
      buttons.forEach(button => {
        const pressed = String(current === 'one-time' && Number(button.dataset.rattanPairs) === Number(quantity.value));
        if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
      });
    };
    buttons.forEach(button => button.addEventListener('click',() => {
      oneTimeQuantity = Number(button.dataset.rattanPairs);
      const oneTime = [...form.querySelectorAll('input[name="selling_plan"]')].find(input => !input.getAttribute('data-appstle-real-value') && !input.value);
      if (oneTime && !oneTime.checked) oneTime.click();
      refresh();
      setQuantity(oneTimeQuantity);
      refresh();
    }));
    form.addEventListener('change',() => queueMicrotask(refresh));
    new MutationObserver(refresh).observe(form,{childList:true,subtree:true});
    refresh();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize);
  else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["trigonal-rattan-video-only"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-tg-rattan-film]').forEach(film => {
      if (film.dataset.initialized) return;
      film.dataset.initialized = 'true';
      const video = film.querySelector('video');
      const toggle = film.querySelector('[data-tg-video-toggle]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let manuallyPaused = false;
      let inView = false;
      const automatic = () => !reduceMotion.matches && !navigator.connection?.saveData;
      const update = () => {
        toggle.textContent = video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
      };
      const play = () => {
        video.muted = true;
        video.defaultMuted = true;
        if (!video.getAttribute('src')) video.src = video.dataset.videoSource;
        video.play().catch(update);
      };
      toggle.hidden = false;
      toggle.addEventListener('click', () => {
        if (video.paused) {
          manuallyPaused = false;
          play();
        } else {
          manuallyPaused = true;
          video.pause();
        }
      });
      video.addEventListener('play', update);
      video.addEventListener('pause', update);
      video.addEventListener('error', update);
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          inView = entries[0].isIntersecting;
          if (!inView) video.pause();
          else if (!document.hidden && automatic() && !manuallyPaused) play();
        }, { threshold: 0.2 });
        observer.observe(video);
      }
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause();
        else if (inView && automatic() && !manuallyPaused) play();
      });
      reduceMotion.addEventListener('change', () => {
        if (reduceMotion.matches) video.pause();
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["trigonal-subscription-copy"] && !Shopify.designMode) return;
  try {
    (() => {
  const marker = document.querySelector('[data-tg-plan-copy]');
  if (!marker) return;
  const percent = Number(marker.dataset.percent);
  if (!Number.isFinite(percent)) return;
  const label = marker.dataset.planLabel.replace(/\b\d+(?:\.\d+)?%/g, percent + '%');
  let queued = false;
  const update = () => {
    queued = false;
    document.querySelectorAll('.appstle_sub_widget option').forEach(option => {
      if (option.value !== marker.dataset.tgPlanCopy) return;
      const offer = option.closest('.appstle_subscription_wrapper_option');
      if (!offer) return;
      const walker = document.createTreeWalker(offer, NodeFilter.SHOW_TEXT);
      let text;
      while ((text = walker.nextNode())) {
        const corrected = text.nodeValue.replace(/\b\d+(?:\.\d+)?%/g, percent + '%');
        if (corrected !== text.nodeValue) text.nodeValue = corrected;
      }
      if (option.textContent !== label) option.textContent = label;
    });
  };
  const observer = new MutationObserver(() => {
    if (!queued) { queued = true; queueMicrotask(update); }
  });
  observer.observe(marker.closest('.product-template__container'), { childList:true, subtree:true, characterData:true });
  update();
})();
  } catch(e) { console.error(e); }
})();

})();
